/**
 * Mock data pre interných používateľov
 */

import { ovmIds } from "./officials";

export const internalUsers = [
  {
    id: "iu-001",
    firstName: "Admin",
    lastName: "Systémový",
    email: "admin@msp.justice.cz",
    phone: "+420221997111",
    role: { name: "ADMIN", displayName: "Administrátor" },
    ovmId: null,
    ovmName: null,
    active: true,
    lastLogin: "2026-02-04T09:00:00.000Z",
    created: "2020-01-01T00:00:00.000Z",
  },
  {
    id: "iu-002",
    firstName: "Jana",
    lastName: "Evidenční",
    email: "jana.evidencni@mfcr.cz",
    phone: "+420257042222",
    role: { name: "EO", displayName: "Evidenční orgán" },
    ovmId: ovmIds.ministerstvo,
    ovmName: "Ministerstvo financí",
    active: true,
    lastLogin: "2026-02-04T08:30:00.000Z",
    created: "2021-03-15T00:00:00.000Z",
  },
  {
    id: "iu-003",
    firstName: "Martin",
    lastName: "Tajemník",
    email: "martin.tajemnik@mfcr.cz",
    phone: "+420257042333",
    role: { name: "TAJEMNIK", displayName: "Tajemník" },
    ovmId: ovmIds.ministerstvo,
    ovmName: "Ministerstvo financí",
    active: true,
    lastLogin: "2026-02-03T16:45:00.000Z",
    created: "2021-03-15T00:00:00.000Z",
  },
  {
    id: "iu-004",
    firstName: "Petra",
    lastName: "Senátní",
    email: "petra.senatni@senat.cz",
    phone: "+420257075111",
    role: { name: "EO", displayName: "Evidenční orgán" },
    ovmId: ovmIds.senat,
    ovmName: "Senát ČR",
    active: true,
    lastLogin: "2026-02-04T10:15:00.000Z",
    created: "2020-06-01T00:00:00.000Z",
  },
  {
    id: "iu-005",
    firstName: "Karel",
    lastName: "Sněmovní",
    email: "karel.snemovni@psp.cz",
    phone: "+420257171111",
    role: { name: "EO", displayName: "Evidenční orgán" },
    ovmId: ovmIds.snemovna,
    ovmName: "Poslanecká sněmovna",
    active: true,
    lastLogin: "2026-02-04T09:45:00.000Z",
    created: "2020-06-01T00:00:00.000Z",
  },
  {
    id: "iu-006",
    firstName: "Lucie",
    lastName: "Pražská",
    email: "lucie.prazska@praha.eu",
    phone: "+420236001111",
    role: { name: "EO", displayName: "Evidenční orgán" },
    ovmId: ovmIds.mestoPraha,
    ovmName: "Magistrát hl. m. Prahy",
    active: true,
    lastLogin: "2026-02-03T14:20:00.000Z",
    created: "2022-01-10T00:00:00.000Z",
  },
  {
    id: "iu-007",
    firstName: "Tomáš",
    lastName: "Brněnský",
    email: "tomas.brnensky@brno.cz",
    phone: "+420542171111",
    role: { name: "EO", displayName: "Evidenční orgán" },
    ovmId: ovmIds.mestoBrno,
    ovmName: "Statutární město Brno",
    active: true,
    lastLogin: "2026-02-04T07:30:00.000Z",
    created: "2022-01-10T00:00:00.000Z",
  },
  {
    id: "iu-008",
    firstName: "Eva",
    lastName: "Krajská",
    email: "eva.krajska@kr-jihomoravsky.cz",
    phone: "+420541651111",
    role: { name: "EO", displayName: "Evidenční orgán" },
    ovmId: ovmIds.krajBrno,
    ovmName: "Jihomoravský kraj",
    active: true,
    lastLogin: "2026-02-02T11:00:00.000Z",
    created: "2021-09-01T00:00:00.000Z",
  },
  {
    id: "iu-009",
    firstName: "Pavel",
    lastName: "Neaktivní",
    email: "pavel.neaktivni@mfcr.cz",
    phone: "+420257042444",
    role: { name: "EO", displayName: "Evidenční orgán" },
    ovmId: ovmIds.ministerstvo,
    ovmName: "Ministerstvo financí",
    active: false,
    lastLogin: "2025-06-15T12:00:00.000Z",
    created: "2021-03-15T00:00:00.000Z",
    deactivatedDate: "2025-07-01T00:00:00.000Z",
    deactivatedReason: "Ukončení pracovního poměru",
  },
];

export default internalUsers;
